<template>
  <UiChip
    :label="label"
    :selected="selected"
    :size="chipSize"
    right-icon="arrow"
    :show-items-count="showItemsCount"
    :label-items-count="labelItemsCount"
    @click="onOpen"
  />
</template>

<script setup lang="ts">
  import { UiChip, Size } from '@experience/core-chips-ui';
  import { MAX_TYPES_IN_BUTTON } from '../lib/const.ts';

  interface Props {
    label: string;
    selected?: boolean;
    isScroll?: boolean;
    itemsCount?: number;
  }

  interface Emits {
    (e: 'open'): void;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();

  const chipSize = computed(() => (props.isScroll ? Size.S : Size.M));

  const showItemsCount = computed(() => (props.itemsCount ?? 0) > MAX_TYPES_IN_BUTTON);

  const labelItemsCount = computed(() => (showItemsCount.value ? props.itemsCount : undefined));

  const onOpen = () => {
    emit('open');
  };
</script>
